
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"7.692","fill":"#D0E0FB"}}),_c('path',{attrs:{"d":"M12.284 12.692h15.384c.18 0 .36.011.538.034a3.172 3.172 0 00-3.727-2.671l-12.652 2.16h-.014c-.795.152-1.501.601-1.975 1.256a4.21 4.21 0 012.446-.78zM27.668 13.846H12.284a3.08 3.08 0 00-3.077 3.077v9.23a3.08 3.08 0 003.077 3.078h15.384a3.08 3.08 0 003.077-3.077v-9.23a3.08 3.08 0 00-3.077-3.078zm-2.283 9.231a1.539 1.539 0 110-3.078 1.539 1.539 0 010 3.078z","fill":"#4661B9"}}),_c('path',{attrs:{"d":"M9.23 20.168v-4.784c0-1.041.578-2.788 2.58-3.166 1.7-.32 3.382-.32 3.382-.32s1.106.77.193.77c-.914 0-.89 1.178 0 1.178.889 0 0 1.13 0 1.13l-3.582 4.062-2.572 1.13z","fill":"#4661B9"}})])
          )
        }
      }
    